module.exports = __webpack_public_path__ + "img/dropdown-arrow.e678bec3.svg";